import { Button } from "./Button";
import { ButtonVariant } from "../config/colors";
import { ButtonSize } from "./Button";
import React, { useEffect, useState } from "react";
import { useStream } from "../hooks/useStream";
import { useTheme } from "../hooks/useTheme";
import { useRouter } from "../hooks/useRouter";
import { CallingState, useCalls } from "@stream-io/video-react-sdk";
import { getCallStreamDataFromCall } from "../utils/StreamService";
import { useAuth } from "../hooks/useAuth";
import Timer from "./Timer";
import { AuthenticationStatusGetStream } from "../store/slices/authSlice";

const LineActiveCall = () => {
    const {statusGetStream} = useStream();

    if(statusGetStream === AuthenticationStatusGetStream.LOGGED) {
        return <LineActiveCallIfGetStream />;
    }

    return null;
}

const LineActiveCallIfGetStream = () => {
    const {isMobile} = useTheme();
    const {leaveCall, removeIdsCallsIgnored} = useStream();
    const {navigateToCall} = useRouter();
    const {currentUserId} = useAuth();
    const calls = useCalls();

    if(calls.length === 0) {
        return null;
    }

    const lastCall = calls[calls.length - 1];
    const callStreamData = getCallStreamDataFromCall(lastCall, currentUserId ?? '');

    let statusText: React.ReactNode = '';
    switch(lastCall.state.callingState) {
        case CallingState.RINGING:
            statusText = 'Connecting...';
            break;
        case CallingState.JOINED:
            statusText = <Timer fromDate={lastCall.state.startedAt} />;
            break;
    }

    console.log(lastCall.state.startedAt);

    const onPress = () => {
        if(lastCall.state.callingState === CallingState.RINGING) {
            removeIdsCallsIgnored(lastCall.id);
        }
        else {
            navigateToCall();
        }
    }

    const onEndCall = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();

        if(lastCall.state.callingState === CallingState.RINGING && !lastCall.isCreatedByMe) {
            lastCall.reject();
        }
        else {
            leaveCall();
        }
    }

    return (
        <div 
            className={`flex items-center gap-2 justify-between h-[40px] shrink-0 bg-brand-orange cursor-pointer ${isMobile ? "px-2" : "px-4"}`}
            onClick={onPress}
        >
            {
                isMobile ? (
                    <div className="flex-1 flex items-center justify-center gap-2">
                        <span className="material-icons">call</span>
                        <span className="font-semibold">{callStreamData?.name}</span>
                    </div>
                ) : (
                    <>
                        <div className="flex-1 flex justify-start">
                            {statusText}
                        </div>
                        <div className="flex items-center justify-center gap-2 font-semibold font-initial">
                            <span className="material-icons">call</span>
                            <span className="font-semibold">{callStreamData?.name}</span>
                        </div>
                        <div className="flex-1 flex justify-end">
                            <Button 
                                onClick={onEndCall}
                                size={ButtonSize.small}
                                variant={ButtonVariant.transparent}
                                className="bg-red-500 dark:bg-red-500 hover:bg-red-600 dark:hover:bg-red-600"
                            > 
                                <span className="material-icons">call_end</span>
                                End call
                            </Button>
                        </div>
                    </>
                )
            }
        </div>
    )
}

export default LineActiveCall;